import { call, put, takeEvery } from "redux-saga/effects";

import {
  CASOS_LIST,
  CASOS_FULLLIST,
  CASOS_LISTA,
  CASOS_FILTER,
  CASOS_CREATE,
  CASOS_CREATE_FORM,
  CASOS_UPDATE,
  CASOS_READ,


} from "./actionTypes";

import {
  
  casosListSuccess,
  casosCreateSuccess,
  casosCreateFormSuccess,
  casosUpdateSuccess,
  casosRequestFailed,
  casosFullListSuccess,
  CasosReadSuccess
 
} from "./actions";

import {
  getCasosList,
  getCasosLista,
  getCasosFilter,
  postCasosCreate,
  postFormCasosCreate,
  patchCasosUpdate,
  getCasosRead,
  getCasosFullList
} from "../../helpers/backend";



function*casosListSaga() {
  console.log("Trayendo lista de casos...");
  try {
    const response = yield call(getCasosList);
    if (response.status === 200) {
      yield put(casosListSuccess(response.data));
    } else {
      yield put(casosRequestFailed(response.data));
    }
  } catch (error) {
    yield put(casosRequestFailed(error.response.data));
  }
}
function*casosFullListSaga() {
  console.log("Trayendo lista de casos de FullList...");
  try {
    const response = yield call(getCasosFullList);
    if (response.status === 200) {
      yield put(casosFullListSuccess(response.data));
    } else {
      yield put(casosRequestFailed(response.data));
    }
  } catch (error) {
    yield put(casosRequestFailed(error.response.data));
  }
}

function*casosListaSaga() {
  console.log("Trayendo lista de casos...");
  try {
    const response = yield call(getCasosLista);
    if (response.status === 200) {
      yield put(casosListSuccess(response.data));
    } else {
      yield put(casosRequestFailed(response.data));
    }
  } catch (error) {
    yield put(casosRequestFailed(error.response.data));
  }
}

function*casosCreateSaga({ payload:casos }) {
  console.log("Creando nuevo casos...");
  try {
    const response = yield call(postCasosCreate,casos);
    if (response.status === 201) {
      yield put(casosCreateSuccess(response.data));
    } else {
      yield put(casosRequestFailed(response.data));
      console.log(response.data)
    }
  } catch (error) {
    yield put(casosRequestFailed(error.response.data));
  }
}

function*casosFormCreateSaga({ payload:casos }) {
  console.log("Creando nuevo casos...");
  try {
    const response = yield call(postFormCasosCreate,casos);
    if (response.status === 201) {
      yield put(casosCreateFormSuccess(response.data));
    } else {
      yield put(casosRequestFailed(response.data));
      console.log(response.data)
    }
  } catch (error) {
    yield put(casosRequestFailed(error.response.data));
  }
}

function*casosFilterSaga({ payload: { changeUrl } }) {
  try {
    const response = yield call(getCasosFilter, { changeUrl });
    if (response.status === 200) {
      yield put(casosListSuccess(response.data));
    } else {
      yield put(casosRequestFailed(response.data));
    }
  } catch (error) {
    yield put(casosRequestFailed(error.response.data));
  }
}

function*casosUpdateSaga({ payload: { id, data } }) {
  console.log("Actualizando datos de la herramienta...");
  
  try {
    const response = yield call(patchCasosUpdate,  id , data);
    if (response.status === 200) {
      yield put(casosUpdateSuccess(response.data));
      
      
    } else {
      yield put(casosRequestFailed(response.data));
      console.log(response.data)
    }
  } catch (error) {
    yield put(casosRequestFailed(error.response.data));
    
  }
}

function* CasosReadSaga({ payload: { id } }) {
  console.log("Probando...");
  try {
    const response = yield call(getCasosRead, id);

    if (response.status === 200) {
       yield put(CasosReadSuccess(response.data));
      } else {
        yield put(casosRequestFailed(response.data));
      }
    } catch (error) {
      yield put(casosRequestFailed(error.response.data));
    }

}

export default function*casosSaga() {
  yield takeEvery(CASOS_LIST,casosListSaga);
  yield takeEvery(CASOS_FULLLIST,casosFullListSaga);
  yield takeEvery(CASOS_LISTA,casosListaSaga);
  yield takeEvery(CASOS_FILTER,casosFilterSaga);
  yield takeEvery(CASOS_CREATE,casosCreateSaga);
  yield takeEvery(CASOS_CREATE_FORM,casosFormCreateSaga);
  yield takeEvery(CASOS_UPDATE,casosUpdateSaga);
  yield takeEvery(CASOS_READ,CasosReadSaga);
}
